import script from "./UiButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiButton.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./UiButton.vue?vue&type=style&index=0&id=b32a6b0a&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__